import {useEffect, useState} from 'react';

// Keeps an element mounted until its exit transition has played, and holds a fresh mount in its hidden
// state for a frame, so the browser has something to transition from
const usePresence = (isPresent, exitMs) => {
    const [isMounted, setIsMounted] = useState(isPresent);
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        if (!isPresent) {
            setIsShown(false);
            const timeoutId = setTimeout(() => setIsMounted(false), exitMs);

            return () => clearTimeout(timeoutId);
        }

        setIsMounted(true);
        // The first frame paints the hidden state, the second starts the transition from it
        let frameId = requestAnimationFrame(() => {
            frameId = requestAnimationFrame(() => setIsShown(true));
        });

        return () => cancelAnimationFrame(frameId);
    }, [isPresent, exitMs]);

    return {isMounted, isShown};
};

export default usePresence;
